/**
 * Channel Service 
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface JsonNode { 
    floatingPointNumber?: boolean;
    missingNode?: boolean;
    integralNumber?: boolean;
    valueNode?: boolean;
    nodeType?: JsonNode.NodeTypeEnum;
    pojo?: boolean;
    'short'?: boolean;
    'int'?: boolean;
    'long'?: boolean;
    'double'?: boolean;
    bigDecimal?: boolean;
    bigInteger?: boolean;
    /** @deprecated */
    textual?: boolean;
    'boolean'?: boolean;
    container?: boolean;
    object?: boolean;
    binary?: boolean;
    number?: boolean;
    string?: boolean;
    array?: boolean;
    empty?: boolean;
    'null'?: boolean;
    'float'?: boolean;
    embeddedValue?: boolean;
}
export namespace JsonNode {
    export const NodeTypeEnum = {
        Array: 'ARRAY',
        Binary: 'BINARY',
        Boolean: 'BOOLEAN',
        Missing: 'MISSING',
        Null: 'NULL',
        Number: 'NUMBER',
        Object: 'OBJECT',
        Pojo: 'POJO',
        String: 'STRING'
    } as const;
    export type NodeTypeEnum = typeof NodeTypeEnum[keyof typeof NodeTypeEnum];
}


